<template>
  <a-spin
    id="app"
    :spinning="$store.state.loading"
    tip="加载中..."
    class="spin loading"
  >
    <router-view></router-view>
  </a-spin>
</template>

<script>
export default {
  name: "App",
  computed: {
    messageCount() {
      return this.$store.state.messageCount;
    },
    message() {
      return this.$store.state.message;
    },
    firstMenuList() {
      return this.$store.state.firstMenuList;
    },
  },
  watch: {
    messageCount(oldVal, newVal) {
      if (newVal !== 0) {
        this.$message.warning(this.message);
      }
    },
  },
  created() {

    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));

      this.$store.commit("changeMedelSign", "baseNewsModel");

      this.$store.commit("changeCheckClassId", this.firstMenuList[0].classId);

      this.$store.commit("changeSecondClass", {});
      this.$store.commit("changeThirdClass", {});

      if (this.$route.name != "login" && this.$route.name != "transfer") {
        this.$router.push({
          path: "/index",
        });
      }
    });
  },
};
</script>

<style scoped lang='scss'>
#app {
  // position: relative;
  .loading {
    overflow: hidden;
  }
  .spin {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue